

























































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Pagination} from 'pansx-utils';
import {Page} from 'pansx-utils';
import {QTableRequestOption} from 'pansx-utils';
import {SecurityUtils} from '@/oauth/SecurityUtils';
import {Customer} from '@/entity/Customer';
import {CustomerDto} from '@/dto/CustomerDto';
import CustomerForm from '@/components/Customer/CustomerForm.vue';
import XHeader from "@/views/KeShangAdmin/XHeader.vue";
import Footer from "@/views/KeShangAdmin/Footer.vue";
import {getModule} from "vuex-module-decorators";
import {CustomerStore} from "@/store/CustomerStore";
import {AuthStore} from "@/oauth/AuthStore";
import {CollectCompany} from "@/entity/CollectCompany";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";
import {FindAllByNameContainingAndCreatorId} from "@/entity/FindAllByNameContainingAndCreatorId";

@Component({
  components: {Footer, XHeader, CustomerForm},
})
export default class CustomerAdminTable extends Vue {
  public data: Customer[] = [];
  @Prop({default: () => new Pagination()})
  public readonly pagination!: Pagination;
  public customerFormDialog = false;
  public CustomerForm = new Customer();
  @Prop({default: () => new Customer()})
  public readonly filter!: Customer;
  public loading = false;
  su = SecurityUtils;
  private customers: Customer[] = [];
  customer = new Customer();
  isAdminOpen = false;
  cs = getModule(CustomerStore);
  ls = getModule(AuthStore);
  rightDrawerOpen = true;
  drawer = false;
  tab = 'group_add';
  collectCompany = new CollectCompany()
  Name = '';
  customerss: Customer[] = [];

  async findAllByNameContainingAndCreatorId() {
    if (this.Name!==null && this.Name!==''){
      try {
        const f = new FindAllByNameContainingAndCreatorId();
        f.name = this.Name;
        f.creatorId = this.su.getLoginUser().id as unknown as number;
        this.data = await CustomerDto.FindAllByNameContainingAndCreatorId(f);
      }catch {
        this.$q.notify({type: 'negative',message: '无结果'})
      }
    }else {
      this.getAll();
    }

  }

  fanghui() {
    this.$router.push("/keShangSelect")
  }

  keShangSelect() {
    this.$router.push({name: 'KeShangSelect'});
  }

  keShangSelect1() {
    this.$router.push({name: 'keShangSelect1'});
  }

  keShangSelect2() {
    this.$router.push({name: 'keShangSelect2'});
  }

  get customerName() {
    return this.collectCompany.companyName;
  }

  async getId(id = this.id) {
    this.customer = await CustomerDto.findById(Number(id));
  }

  ToKeShangRegister() {
    this.$router.push({name:'KeShangRegister'})
  }

  goToZiZhangHaoGuanLi() {
    this.$router.push({name: 'ZiZhangHao'});
  }

  get id() {
    return this.$route.params.id as string;
  }

  getChineseByIsViewPass(b: boolean | null) {
    if (b != null) {
      return b ? '已通过' : '未通过';
    }
    return "未审核";
  }

  saveCompany() {
    sessionStorage.setItem("name", this.cs.currentCustomer.name)
  }

  companyName() {
    const item: string | null = sessionStorage.getItem("name");
    if (item == null) {
      return "home"
    }
    return item;
  }

  get userName() {
    return this.ls.loginUser.username
  }


  toggleRightDrawer() {
    this.rightDrawerOpen = !this.rightDrawerOpen;
  }


  async findAll() {
    const id = this.su.getLoginUser().id as number;
    const customer = new Customer();
    customer.creatorId = id;
    this.customers = await CustomerDto.findAll(customer);
    for (const value of this.su.getLoginUser().authorities) {
      if (value.authority.startsWith('ROLE_CUSTOMER_')) {
        const id = Number(value.authority.replace('ROLE_CUSTOMER_', '').replace('_ADMIN', ''));
        if (!this.customers.some(c => c.id === id)) {
          const customer = await CustomerDto.findById(id);
          if (typeof customer !== 'undefined') {
            this.customers.push(customer);
          }
        }
      }
    }
  }

  // suc() {
  //   AuthTokenDto.logout();
  //   this.$router.push({name: 'login'});
  // }

  handleClick(c: Customer) {
    getModule(CustomerStore).setCurrentCustomer(c);
    this.rightDrawerOpen = !this.rightDrawerOpen;

    this.saveCompany();
    //const id = c.id + '';
    //this.$router.push({name: 'KeShangMain', params: {id: id}});
  }


  public get columns() {
    let columns = Customer.getColumns();
    columns.push({
      label: ' ',
      name: 'edit',
      field: '',
    });
    columns = columns.filter(value => !['creatorId', 'isReviewPass'].some(s => value.name === s));
    return columns;
  }


  // group= 'op1'
  // options= [
  //   {
  //     label: '大于',
  //     value: 'op1'
  //   },
  //   {
  //     label: '等于',
  //     value: 'op2'
  //   },
  //   {
  //     label: '小于',
  //     value: 'op3'
  //   }
  // ]


  public async getAll(q?: QTableRequestOption) {
    this.loading = true;
    try {
      if (typeof q !== 'undefined') {
        this.applyPagination(q.pagination);
      }
      const page = await CustomerDto.allPage(
          this.filter,
          this.pagination,
      );
      const pg: Pagination = Page.of(page).getPagination();
      if (typeof q !== 'undefined') {
        pg.sortBy = q.pagination.sortBy;
        pg.descending = q.pagination.descending;
      }
      this.applyPagination(pg);
      this.data = page.content;
    } catch (e) {
      this.$q.notify({message: '错误:' + e, color: 'red'});
    } finally {
      this.loading = false;
    }
  }

  private applyPagination(q: Pagination | undefined) {
    if (typeof q !== 'undefined') {
      this.pagination.descending = q.descending;
      this.pagination.page = q.page;
      this.pagination.rowsNumber = q.rowsNumber;
      this.pagination.rowsPerPage = 99999;
      this.pagination.sortBy = q.sortBy;
    }
  }

  async save(d: Customer) {
    try {
      await CustomerDto.save(d);
      this.$q.notify('保存成功!');
    } catch (e) {
      this.$q.notify({message: '错误:' + e, color: 'red'});
    }
  }

  public editCustomer(customer: Customer) {
    this.CustomerForm = Customer.of(customer);
    this.customerFormDialog = true;
  }

  public handleCustomerFormSubmit() {
    this.CustomerForm = new Customer();
    this.customerFormDialog = false;
    this.getAll();
  }

  public async addCustomer() {
    this.CustomerForm = new Customer();
    this.customerFormDialog = true;
  }

  async findAllCompanyName() {
    const id = this.su.getLoginUser().id as number;
    // const  collectName = new  CollectCompany();
    this.collectCompany = await CollectCompanyDto.findById(id)
    // console.log(this.collectCompany)
    // this.collectCompany.companyName = this.module.currentCustomer.name
  }


  public async deleteCustomer(customer: Customer) {
    try {
      const id = customer.id;
      if (typeof id !== 'undefined') {
        await new Promise((resolve, reject) => {
          this.$q
              .dialog({
                cancel: true,
                message: '真的要删除吗?',
                persistent: true,
              })
              .onOk(async () => {
                await CustomerDto.delete(id);
                resolve(true);
              })
              .onCancel(reject);
        });
      }
      this.$q.notify({message: '删除成功', color: 'green'});
      await this.getAll();
    } catch (e) {
      this.$q.notify({message: '删除失败', color: 'red'});
    }
  }

  public mounted() {
    this.filter.creatorId = this.su.getLoginUser().id as number;
    this.getAll();
    this.findAll()
    this.findAllCompanyName();
  }

}
